module.exports = __webpack_public_path__ + "files/zingg.0eebbd8355cc66994459127f30629165.pdf";